(function () {
  'use strict';

  function pauseVideo(wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;
    try {
      video.pause();
    } catch (e) {
      /* ignore */
    }
  }

  function playVideo(wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;
    video.muted = true;
    video.playsInline = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        /* autoplay blocked — poster / fallback image remains visible */
      });
    }
  }

  function initPreviewVideos(root) {
    if (!root) return;
    var wraps = root.querySelectorAll('[data-be-preview-video]');
    if (!wraps.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      wraps.forEach(pauseVideo);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      wraps.forEach(playVideo);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
            playVideo(entry.target);
          } else {
            pauseVideo(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: [0, 0.35, 0.6] }
    );

    wraps.forEach(function (wrap) {
      if (wrap.closest('[data-be-pcard-video]')) return;
      observer.observe(wrap);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPreviewVideos(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initPreviewVideos(event.target);
  });
})();
